export default __webpack_public_path__ + "98db9a1ffb1a6c413235f3d969f58cd4.png";